class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.details = this.querySelector('details')
    this.button = this.querySelector('button');
    this.content = this.querySelector('details .content');
    this.curtain = this.querySelector('details .content .mega-menu__content');
    this.animation = null;
    this.button.addEventListener('click', this.onClick.bind(this));
    this.curtain.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event){
    event.stopPropagation();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if(this.mainDetailsToggle.open){
      this.content.querySelector(".mega-menu__overlayer").animate(
        [
          { 
            background: "rgba(0, 0, 0, 0.6)",
          },
          { 
            background: "rgba(0, 0, 0, 0)"
          },
        ], 
        {
        duration: 250,
        easing: 'ease-out'
      });
      this.animation = this.content.querySelector(".mega-menu__content").animate(
        [
          { 
            transform: "translateY(0rem)",
            opacity:1
          },
          { 
            transform: "translateY(-1.5rem)",
            opacity:0
          },
        ], 
        {
        duration: 250,
        easing: 'ease-out'
      });

      this.animation.play();
      
      this.animation.onfinish = () =>{ 
        this.mainDetailsToggle.removeAttribute('open');
        document.querySelector('#shopify-section-header').classList.remove("order-menu-open");
      }
      this.animation.oncancel = () => this.isClosing = false;
    }    
    else{
      this.mainDetailsToggle.setAttribute('open',true);
      document.querySelector('#shopify-section-header').classList.add("order-menu-open");

      this.animation = this.content.querySelector(".mega-menu__content").animate(
        [
          { 
            transform: "translateY(-1.5rem)",
            opacity:0
          },
          { 
            transform: "translateY(0rem)",
            opacity:1
          },
        ], 
        {
        duration: 500,
        easing: 'ease-out'
      });
      this.content.querySelector(".mega-menu__overlayer").animate(
        [
          { 
            background: "rgba(0, 0, 0, 0)",
          },
          { 
            background: "rgba(0, 0, 0, 0.6)"
          },
        ], 
        {
        duration: 500,
        easing: 'ease-out'
      });

      this.animation.play();
      // in case we need it
      this.animation.onfinish = () =>{ }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  
  }

  onToggle(event) {
    event.preventDefault();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);